<script>
import dynamicCollectionItemClass from '@/options/mixins/dynamic-collection-item-class';

export default {
    name: 'dynamic-collection-item-width',
    mixins: [dynamicCollectionItemClass],

    data() {
        return {
            displayName: 'Item Container Width',
            tailwindDefinitionProp: 'width',
            defaultUnit: 'auto',
            itemClassesNew: null,
        };
    },
};
</script>
